/* Sanftlage Orthotal-Nachbau: Galerie, Auswahl, Paket, Warenkorb, Klappfelder, Kaufleiste */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Klappfelder: bei Orthotal liegt der Inhalt neben <details>, nicht darin
  $$('.accordion').forEach((acc) => {
    const det = $('details', acc);
    const wrap = $('.accordion__content-wrapper', acc);
    if (!det || !wrap) return;
    wrap.style.display = 'none';
    $('summary', det).addEventListener('click', (e) => {
      e.preventDefault();
      const open = wrap.style.display !== 'none';
      wrap.style.display = open ? 'none' : 'block';
      det.open = !open;
      acc.classList.toggle('ot-open', !open);
    });
  });

  // Galerie
  const list = $('ul.product__media-list');
  if (list) {
    const slides = $$('[data-ot-slide]', list);
    const thumbs = $$('[data-ot-thumb]');
    let cur = 0;
    const show = (i) => {
      cur = (i + slides.length) % slides.length;
      list.scrollTo({ left: slides[cur].offsetLeft - list.offsetLeft, behavior: 'smooth' });
      slides.forEach((s, j) => s.classList.toggle('is-active', j === cur));
      thumbs.forEach((t, j) => (j === cur ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(+t.dataset.otThumb)));
    $$('.slider-button--prev, .slider-button--next').forEach((b) => {
      if (!b.closest('#' + list.closest('slider-component')?.id) && !b.closest('media-gallery')) return;
      b.removeAttribute('disabled');
      b.addEventListener('click', (e) => {
        e.preventDefault();
        if (b.closest('.thumbnail-slider')) return;
        show(cur + (b.classList.contains('slider-button--next') ? 1 : -1));
      });
    });
    list.addEventListener('scroll', () => {
      const w = slides[0] ? slides[0].offsetWidth : 1;
      const i = Math.round(list.scrollLeft / w);
      if (i !== cur && slides[i]) {
        cur = i;
        thumbs.forEach((t, j) => (j === cur ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
      }
    }, { passive: true });
  }

  // Galerie nach Farbe filtern
  const filterGallery = (farbe) => {
    const color = farbe === 'Schwarz' ? 'schwarz' : 'weiss';
    const allSlides = $$('[data-ot-color]', list?.parentElement || document);
    const allThumbs = $$('[data-ot-color]', $('ul.thumbnail-list')?.parentElement || document);
    allSlides.forEach((s) => { s.style.display = s.dataset.otColor === color ? '' : 'none'; });
    allThumbs.forEach((t) => { t.style.display = t.dataset.otColor === color ? '' : 'none'; });
    const first = allSlides.find((s) => s.dataset.otColor === color);
    if (first && list) {
      list.scrollTo({ left: first.offsetLeft - list.offsetLeft, behavior: 'instant' });
      $$('[data-ot-slide]', list).forEach((s) => s.classList.remove('is-active'));
      first.classList.add('is-active');
    }
  };

  // Auswahl und Paket
  const vdata = $('script[data-ot-variants]');
  if (!vdata) return;
  const variants = JSON.parse(vdata.textContent);
  const st = { groesse: 'M', seite: 'Rechts', farbe: 'Weiß', bundle: '1', seite1: 'Rechts', seite2: 'Links', q: ['Links', 'Links', 'Rechts', 'Rechts'] };
  const QUAD = { 4: '4× Links', 3: '3× Links + 1× Rechts', 2: '2× Links + 2× Rechts', 1: '1× Links + 3× Rechts', 0: '4× Rechts' };
  const money = (c) => (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  const varInput = $('[data-ot-variant]');

  const pick = () => {
    let side = st.seite;
    if (st.bundle === '2') {
      side = st.seite1 === st.seite2 ? '2× ' + st.seite1 : 'Links + Rechts';
    }
    if (st.bundle === '4') {
      side = QUAD[st.q.filter((s) => s === 'Links').length];
    }
    return variants.find((v) => v.o1 === side && v.o2 === st.farbe && v.o3 === st.groesse);
  };
  const sync = () => {
    $$('[data-ot-pill]').forEach((i) => (i.checked = st[i.dataset.otPill] === i.value));
    $$('[data-ot-label]').forEach((l) => {
      const g = l.dataset.otLabel;
      const inp = $(`[data-ot-pill="${g}"][value="${st[g]}"]`);
      const name = { groesse: 'Größe', seite: 'Seite', farbe: 'Farbe' }[g];
      l.textContent = `${name}: ${inp ? inp.dataset.label : st[g]}`;
    });
    $$('[data-ot-pair="groesse1"], [data-ot-pair="groesse2"], [data-ot-quad="groesse"], [data-ot-quad="groesse-x"]').forEach((s) => (s.value = st.groesse));
    [1, 2, 3, 4].forEach((n) => { const s = $(`[data-ot-quad="seite${n}"]`); if (s) s.value = st.q[n - 1]; });
    const s1 = $('[data-ot-pair="seite1"]'); if (s1) s1.value = st.seite1;
    const s2 = $('[data-ot-pair="seite2"]'); if (s2) s2.value = st.seite2;
    $$('[data-ot-bar]').forEach((b) => {
      const on = b.dataset.otBar === st.bundle;
      b.classList.toggle('kaching-bundles__bar--selected', on);
      $('input', b).checked = on;
    });
    const v = pick();
    if (v && varInput) varInput.value = v.id;
    const btn = $('[data-ot-atc]');
    if (btn) btn.disabled = !(v && v.ok !== false);
    filterGallery(st.farbe);
  };
  $$('[data-ot-pill]').forEach((i) => i.addEventListener('change', () => {
    st[i.dataset.otPill] = i.value;
    if (i.dataset.otPill === 'seite') st.seite1 = i.value;
    sync();
  }));
  $$('[data-ot-bar]').forEach((b) => {
    $('input', b).addEventListener('change', () => { st.bundle = b.dataset.otBar; sync(); });
    $('.kaching-bundles__bar-main', b)?.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); st.bundle = b.dataset.otBar; sync(); } });
  });
  $$('[data-ot-pair]').forEach((s) => {
    s.addEventListener('click', (e) => e.stopPropagation());
    s.addEventListener('change', () => {
      const k = s.dataset.otPair;
      if (k.startsWith('groesse')) st.groesse = s.value;
      if (k === 'seite1') { st.seite1 = s.value; st.seite = s.value; }
      if (k === 'seite2') st.seite2 = s.value;
      st.bundle = '2';
      sync();
    });
  });

  $$('[data-ot-quad]').forEach((s) => {
    s.addEventListener('click', (e) => e.stopPropagation());
    s.addEventListener('change', () => {
      const k = s.dataset.otQuad;
      if (k === 'groesse') st.groesse = s.value;
      if (k.startsWith('seite')) st.q[+k.slice(5) - 1] = s.value;
      st.bundle = '4';
      sync();
    });
  });

  // In den Warenkorb (mit Liefergarantie, falls an), dann direkt zur Kasse
  const addToCart = async (btn) => {
    const v = pick();
    if (!v) return;
    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');
    try {
      let items = [{ id: v.id, quantity: 1 }];
      // 4er wie Sohlenwerk: 2 bezahlte Einzelstücke + 2 Gratis-Stücke (eigenes Produkt zu 0 €)
      const gdata = document.querySelector('script[data-ot-gratis]');
      if (st.bundle === '4' && gdata) {
        const gratis = JSON.parse(gdata.textContent);
        const nL = st.q.filter((s) => s === 'Links').length;
        const sides = [...Array(nL).fill('Links'), ...Array(4 - nL).fill('Rechts')];
        const zaehle = (arr) => arr.reduce((m, s) => ((m[s] = (m[s] || 0) + 1), m), {});
        const finde = (liste, s) => liste.find((x) => x.o1 === s && x.o2 === st.farbe && x.o3 === st.groesse);
        const neu = [];
        Object.entries(zaehle(sides.slice(0, 2))).forEach(([s, n]) => { const x = finde(variants, s); if (x) neu.push({ id: x.id, quantity: n }); });
        Object.entries(zaehle(sides.slice(2))).forEach(([s, n]) => { const x = finde(gratis, s); if (x) neu.push({ id: x.id, quantity: n }); });
        if (neu.reduce((a, i) => a + i.quantity, 0) === 4) items = neu;
      }
      const lg = document.querySelector('[data-ot-lg] input');
      if (lg && lg.checked && lg.dataset.vid) items.push({ id: +lg.dataset.vid, quantity: 1 });
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || 'Fehler');
      // Offer-Test: Gruppe als Warenkorb-Merkmal mitgeben, bei Gruppe B die Rabattcodes für die Orthotal-Staffel
      const gruppe = window.SL_ANGEBOT || 'A';
      try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { angebot: gruppe } }) }); } catch (e) {}
      const codes = { 1: 'SLB1-K7Q,SLBV-3TX', 2: 'SLB2-P4M,SLBV-3TX', 4: 'SLB4-W9R' }[st.bundle];
      window.location.href = gruppe === 'B' && codes ? '/checkout?discount=' + encodeURIComponent(codes) : '/checkout';
    } catch (e) {
      window.location.href = '/cart';
    } finally {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
    }
  };
  $$('[data-ot-atc]').forEach((b) => b.addEventListener('click', () => addToCart(b)));

  // Haftende Kaufleiste
  const sticky = $('sticky-atc');
  const mainBtn = $('[data-ot-atc]');
  if (sticky && mainBtn) {
    const io = new IntersectionObserver(([e]) => {
      // Leiste immer zeigen, solange der Kaufknopf nicht im Bild ist (auch vor dem Knopf)
      const past = !e.isIntersecting;
      sticky.classList.toggle('sticky-atc--visible', past);
      sticky.classList.toggle('ot-sticky-on', past);
    });
    io.observe(mainBtn);
    $('[data-ot-sticky-btn]', sticky)?.addEventListener('click', () => {
      const t = document.getElementById(sticky.dataset.scrollDestination.replace('#', '')) || mainBtn;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
    });
  }
  sync();
  // Sprungmarke "Jetzt kaufen" auch beim Seitenaufruf ansteuern
  if (location.hash === '#kaufen') {
    const k = document.getElementById('kaufen');
    if (k) setTimeout(() => window.scrollTo({ top: k.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' }), 300);
  }
})();

